/* global URLSearchParams */
import { useEffect } from 'react';
import { HOMEPAGE } from '@/config/router';
import { canLoginToAdmin, showNoLoginPermissionError, useUserActions } from '@/store/userStore';
import { useRouter } from '@/router/hooks';
import userService from '@/api/services/userService';
import { toast } from 'sonner';

function LoginSuccessPage() {
  const router = useRouter();
  const { setUserToken, setUserInfo, clearUserInfoAndToken } = useUserActions();

  useEffect(() => {
    const handleLogin = async () => {
      const hash = window.location.hash;
      const queryString = hash.split('?')[1] || '';
      const params = new URLSearchParams(queryString);

      console.log('LoginSuccessPage params:', params, queryString);
      const token = params.get('token');

      if (token) {
        const accessToken = 'Bearer ' + token;

        try {
          const user = await userService.getProfile(accessToken);
          if (!canLoginToAdmin(user)) {
            clearUserInfoAndToken();
            showNoLoginPermissionError();
            router.replace('/login');
            return;
          }

          setUserToken({ accessToken });
          setUserInfo(user);

          toast.success('Sign in success!', {
            closeButton: true,
          });
          router.replace(HOMEPAGE);
        } catch (error) {
          console.error('Failed to fetch user profile:', error);
          clearUserInfoAndToken();
          showNoLoginPermissionError();
          router.replace('/login');
        }
      } else {
        router.replace('/login');
      }
    };

    handleLogin();
  }, []);

  return null;
}

export default LoginSuccessPage;
